$('.btn-sidebar').on('click', function(){
	var $this = $(this);
	$this.toggleClass('enabled');
})